"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  created: function created() {
    var logo = this.$store.getters.config;

    if (this.$store.getters.isMerchant || this.$store.getters.isAgent) {
      logo.logoPath = this.$store.getters.merchLogo;
    }

    if (logo.logoPath) this.logo = logo;
  },
  data: function data() {
    return {
      logo: null
    };
  },
  methods: {
    logoUrl: function logoUrl(imgFileName) {
      if (this.$store.getters.isMerchant || this.$store.getters.isAgent) {
        var merch_logo = this.$store.getters.merchLogo;
        if (merch_logo) return merch_logo;
      }

      try {
        return require("../../../assets/logos/".concat(imgFileName));
      } catch (e) {
        console.log(e);
        this.logo = null;
      }
    }
  }
};
exports.default = _default;